import { createRouter, createWebHistory } from 'vue-router';
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/views/HomePage.vue'),
            meta: {
                title: 'Eckpunkt Drink&Food - Lieferdienst & Dine-In in Nordhorn',
                description: 'Willkommen bei Eckpunkt - Ihrem Smashburger Restaurant mit Dine-In Option. Frische Speisen, schneller Service und gemütliche Atmosphäre.',
                keywords: 'Drink&Food, Smash-Burger, Restaurant, Dine-In, Nordhorn, Eckpunkt, frische Speisen'
            }
        },
        {
            path: '/speisekarte',
            component: () => import('@/views/MenuPage.vue'),
            meta: {
                title: 'Speisekarte - Eckpunkt Restaurant',
                description: 'Entdecken Sie unsere vielfältige Speisekarte mit frischen Fast Food Gerichten und Restaurant-Klassikern.',
                keywords: 'Speisekarte, Menü, Fast Food, Burger, Pizza, Salate'
            }
        },
        {
            path: '/speisekarte/:category',
            component: () => import('@/views/MenuPage.vue'),
            meta: {
                title: 'Speisekarte - Eckpunkt Restaurant',
                description: 'Entdecken Sie unsere vielfältige Speisekarte mit frischen Fast Food Gerichten und Restaurant-Klassikern.',
                keywords: 'Speisekarte, Menü, Fast Food, Burger, Pizza, Salate'
            }
        },
        {
            path: '/speisekarte/:category/:product',
            component: () => import('@shared').then(m => ({ default: m.ProductDetailsPage })),
            meta: {
                title: 'Speisekarte - Eckpunkt Restaurant',
                description: 'Entdecken Sie unsere vielfältige Speisekarte mit frischen Fast Food Gerichten und Restaurant-Klassikern.',
                keywords: 'Speisekarte, Menü, Fast Food, Burger, Pizza, Salate'
            }
        },
        {
            path: '/pdf/speisekarte',
            component: () => import('@shared').then(m => ({ default: m.MenuPdfPage })),
            meta: {
                title: 'Speisekarte (PDF) - Eckpunkt Restaurant',
                description: 'Unsere Speisekarte als PDF zum Anzeigen und Herunterladen.'
            }
        },
        {
            path: '/kontakt',
            component: () => import('@/views/ContactPage.vue'),
            meta: {
                title: 'Kontakt & Anfahrt - Eckpunkt Restaurant',
                description: 'Kontaktieren Sie Eckpunkt Restaurant. Adresse, Telefon, Öffnungszeiten und Anfahrtsbeschreibung.',
                keywords: 'Kontakt, Adresse, Telefon, Öffnungszeiten, Anfahrt'
            }
        },
        {
            path: '/impressum',
            component: () => import('@shared/views/ImpressumPage.vue'),
            meta: {
                title: 'Impressum & Datenschutz - Eckpunkt Restaurant',
                description: 'Impressum und Datenschutzerklärung des Eckpunkt Restaurants in Nordhorn',
                keywords: 'Impressum, Datenschutz, Kontakt, Rechtliches, DSGVO'
            }
        },
        {
            path: '/datenschutz',
            redirect: '/impressum'
        },
        // TODO: Re-enable when CartPage is created
        // {
        //   path: '/warenkorb',
        //   component: () => import('@/views/CartPage.vue'),
        //   meta: { 
        //     title: 'Warenkorb - Eckpunkt Restaurant',
        //     description: 'Ihr Warenkorb bei Eckpunkt Restaurant. Bestellung überprüfen und online bestellen.',
        //     keywords: 'Warenkorb, Bestellung, online bestellen'
        //   }
        // },
        // TODO: Re-enable when AccountPage is created
        // {
        //   path: '/account',
        //   component: () => import('@/views/AccountPage.vue'),
        //   meta: { 
        //     title: 'Mein Konto - Eckpunkt Restaurant',
        //     description: 'Ihr persönliches Konto bei Eckpunkt Restaurant. Bestellhistorie, Favoriten und Einstellungen.',
        //     keywords: 'Konto, Account, Bestellhistorie, Profil'
        //   }
        // },
        {
            path: '/checkout',
            component: () => import('@shared').then(m => ({ default: m.CheckoutPage })),
            meta: {
                title: 'Bestellung abschließen - Eckpunkt Restaurant',
                description: 'Schließen Sie Ihre Bestellung bei Eckpunkt Restaurant ab. Lieferung oder Abholung.',
                keywords: 'Checkout, Bestellung, Lieferung, Abholung, bestellen'
            }
        },
        {
            path: '/order-success',
            component: () => import('@shared').then(m => ({ default: m.OrderSuccessPage })),
            meta: {
                title: 'Bestellung erfolgreich - Eckpunkt Restaurant',
                description: 'Ihre Bestellung bei Eckpunkt Restaurant wurde erfolgreich aufgegeben.',
                keywords: 'Bestellung erfolgreich, Bestätigung, Order Success'
            }
        },
        {
            path: '/order-status/:orderNumber',
            component: () => import('@shared/views/OrderStatusPage.vue'),
            props: true, // ✅ Pass route params as props
            meta: {
                title: 'Bestellstatus - Eckpunkt Restaurant',
                description: 'Verfolgen Sie den Status Ihrer Bestellung bei Eckpunkt Restaurant in Echtzeit.',
                keywords: 'Bestellstatus, Order Status, Verfolgung, Bestellung verfolgen'
            }
        },
        {
            path: '/feedback/:uuid',
            component: () => import('@shared/views/FeedbackPage.vue'),
            props: true,
            meta: {
                title: 'Feedback - Eckpunkt Restaurant',
                description: 'Bewerten Sie Ihre Bestellung und helfen Sie uns, besser zu werden.',
                keywords: 'Feedback, Bewertung, Sterne'
            }
        },
        // TODO: Re-enable when PayPalDemoPage is created
        // {
        //   path: '/paypal-demo',
        //   component: () => import('@/views/PayPalDemoPage.vue'),
        //   meta: { 
        //     title: 'PayPal Checkout Demo - Eckpunkt Restaurant',
        //     description: 'Demo und Test für PayPal Checkout Integration bei Eckpunkt Restaurant.',
        //     keywords: 'PayPal, Demo, Checkout, Test, Payment'
        //   }
        // },
        // Legacy redirects (für alte englische URLs)
        {
            path: '/menu',
            redirect: '/speisekarte'
        },
        {
            path: '/reservation',
            redirect: '/reservierung'
        },
        {
            path: '/about',
            redirect: '/ueber-uns'
        },
        {
            path: '/contact',
            redirect: '/kontakt'
        },
        {
            path: '/cart',
            redirect: '/warenkorb'
        },
        // 404 Route
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@shared').then(m => ({ default: m.NotFoundPage })),
            meta: {
                title: '404 - Seite nicht gefunden - Eckpunkt Restaurant',
                description: 'Die gesuchte Seite wurde nicht gefunden. Zurück zur Startseite von Eckpunkt Restaurant.'
            }
        }
    ]
});
// Global navigation guard for SEO meta tags
router.beforeEach((to, _from, next) => {
    // Set page title
    if (to.meta?.title) {
        document.title = to.meta.title;
    }
    // Set meta description
    if (to.meta?.description) {
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.setAttribute('name', 'description');
            document.getElementsByTagName('head')[0].appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', to.meta.description);
    }
    // Set meta keywords
    if (to.meta?.keywords) {
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.setAttribute('name', 'keywords');
            document.getElementsByTagName('head')[0].appendChild(metaKeywords);
        }
        metaKeywords.setAttribute('content', to.meta.keywords);
    }
    next();
});
export default router;
